import React from 'react';
import { NoData, Skelton, Table } from 'src/@vymo/ui/blocks';
import Accordion from 'src/@vymo/ui/blocks/accordion';
import { getRevyreConfig } from 'src/models/lmsConfig/selectors';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { TAB_STATUS_KEYS } from '../../constant';
import { getRelatedRecords, getStatus } from '../../selector';
import { getTableData, handleRelatedRecordNavigation } from './queries';
import styles from '../../index.module.scss';

function RelatedRecords(props) {
  const { module } = props;
  const dispatch = useAppDispatch();
  const relatedRecords = useAppSelector((state) =>
    getRelatedRecords(state, module.code),
  );
  const revyreConfig = useAppSelector(getRevyreConfig);
  const tableData = getTableData(props, relatedRecords, module, revyreConfig);
  const status = useAppSelector((state) =>
    getStatus(state, TAB_STATUS_KEYS.RELATED_RECORDS),
  );

  return (
    <div className={styles.detailsWrapper__detailsBody__relatedRecords}>
      {status === 'loading' && <Skelton rounded lines={8} />}
      {status === 'error' && (
        <NoData message={`Error fetching ${module?.name}`} />
      )}
      {status === 'done' &&
        tableData.map((table, idx) => (
          <Accordion
            title={table.name}
            type="subtle"
            open={idx === 0}
            className={
              styles.detailsWrapper__detailsBody__relatedRecords__accordion
            }
          >
            <Table
              isAccordion={false}
              tableData={table.list}
              columnConfigs={table.columns}
              tableConfig={{
                name: table.name,
                hideColumnConfigurator: true,
                onRowClick: (rowId) =>
                  handleRelatedRecordNavigation(rowId, props, dispatch),
              }}
            />
          </Accordion>
        ))}
    </div>
  );
}

export default RelatedRecords;
